import React, { memo } from "react";
import { uid } from "uid";

export default memo(function ImageAdd({
	register,
	errors,
	fields,
	remove,
	append,
	defaultField,
	imageRequired,
	setFields,
}) {
	const addField = () => {
		let id = uid(16);
		let newDefault = { ...defaultField, _id: id };
		setFields([...fields, newDefault]);
		append(newDefault);
	};
	const removeField = (index) => {
		remove(index);
		setFields((prevFields) => {
			const updatedFields = [...prevFields];
			updatedFields.splice(index, 1);
			return updatedFields;
		});
	};

	return (
		<div>
			<div className="mt-10 ">
				<label className="font-18"> Images:</label>
			</div>
			<div className="border-1 p-10">
				{fields.map((field, index) => (
					<div key={index}>
						<div className="flex justify-between">
							<span>{index + 1}#</span>
							<button
								className="btn btn-sm btn-danger float-right"
								type="button"
								onClick={() => removeField(index)}>
								-
							</button>
						</div>
						<div className="p-10 mx-40 ">
							<input
								type="hidden"
								value={field._id}
								{...register(`pic.${index}._id`, {
									onChange: (e) => {
										console.log(e.target.value, "e.target.value");
										setFields((prevFields) => {
											const updatedFields = [...prevFields];
											updatedFields[index]._id = e.target.value;
											return updatedFields;
										});
									},
								})}
							/>
							<div className="input-wrapper">
								<input
									type="text"
									placeholder="Image Title...."
									className="input"
									value={field.title}
									{...register(`pic.${index}.title`, {
										onChange: (e) => {
											setFields((prevFields) => {
												const updatedFields = [...prevFields];
												updatedFields[index].title = e.target.value;
												return updatedFields;
											});
										},
									})}
								/>
							</div>
							<div className="text-danger text-sm ml-3 pt-1">
								{errors?.pic?.[index]?.title && (
									<span>{errors.pic[index].title.message}</span>
								)}
							</div>
							<div className="input-wrapper">
								<textarea
									className="input"
									value={field.description}
									placeholder="Image Description...."
									{...register(`pic.${index}.description`, {
										onChange: (e) => {
											setFields((prevFields) => {
												const updatedFields = [...prevFields];
												updatedFields[index].description = e.target.value;
												return updatedFields;
											});
										},
									})}></textarea>
							</div>
							<div className="text-danger text-xs ml-3 pt-1 ">
								{errors?.pic?.[index]?.description && (
									<span>{errors.pic[index].description.message}</span>
								)}
							</div>
							<div className="input-video-url mt-20">
								<label className="text-xs ml-3 pt-1">Upload Image</label>
								<input
									type="file"
									required={imageRequired}
									accept="image/png, image/gif, image/jpeg"
									{...register(`pic.${index}.image`)}
								/>
							</div>
							<div className="text-danger text-xs ml-3 pt-1">
								{errors?.pic?.[index]?.image && (
									<span>{errors.pic[index].image.message}</span>
								)}
							</div>
						</div>
					</div>
				))}

				<div className="p-10 mb-40">
					<button
						className="btn btn-sm btn-primary ml-10 float-right"
						type="button"
						onClick={() => addField()}>
						+ Add
					</button>
				</div>
			</div>
		</div>
	);
});
